
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.75 11c1.769 0 3.208-1.439 3.208-3.208 0-1.77-1.44-3.208-3.208-3.208A3.212 3.212 0 005.54 7.792C5.541 9.56 6.981 11 8.75 11zm-6.417 4.813c0-2.136 4.272-3.209 6.417-3.209 2.145 0 6.416 1.073 6.416 3.209v1.604H2.333v-1.604zm6.417-1.375c-1.641 0-3.502.614-4.272 1.146h8.543c-.77-.532-2.63-1.146-4.271-1.146zm1.375-6.646c0-.761-.614-1.375-1.375-1.375s-1.375.614-1.375 1.375c0 .76.614 1.375 1.375 1.375.76 0 1.375-.614 1.375-1.375zm5.078 4.867c1.063.77 1.797 1.797 1.797 3.154v1.604h3.666v-1.604c0-1.852-3.208-2.906-5.463-3.154zm2.255-4.867c0 1.769-1.44 3.208-3.208 3.208-.495 0-.954-.119-1.375-.32a4.987 4.987 0 00.916-2.888c0-1.073-.339-2.072-.916-2.888.421-.201.88-.32 1.375-.32 1.769 0 3.208 1.439 3.208 3.208z","fill":"#C4C4C4"}})])
          )
        }
      }
    